export const formatDateTime = (date) =>
  new Date(date).toLocaleString("en-IN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
export const formatDate = (date) =>
  new Date(date).toLocaleString("en-IN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
